import { ExternalIntegration, WordPressProfile } from 'api/clients/ExternalIntegrationsClient'
import Styles from './ExternalIntegrationSelect.module.scss'
import { AvatarWithPlatformIcon } from './AvatarWithPlatformIcon'
import { integrationToName } from 'components/IntegrationRequiredModal/IntegrationRequiredModal'

export const SelectedItem = ({
  item,
  variant,
  maxWidth,
}: {
  item: ExternalIntegration
  variant: 'condensed' | 'default' | 'ghost'
  maxWidth?: number
}) => {
  const defaultVariant = variant === 'condensed' || variant === 'default'
  const size = defaultVariant ? 'md' : 'xs'

  return (
    <div className={Styles.selectedItem}>
      <AvatarWithPlatformIcon
        data-testid="avatar-platform-icon"
        data-size={size}
        size={size}
        avatar={item.picture}
        platform={item.provider}
      />
      <div className={Styles[variant]} style={{ maxWidth }}>
        <span className={Styles.name}>{item.name || (item.additional_data as WordPressProfile)?.url}</span>
        <span className={Styles.provider}>{integrationToName[item.provider]}</span>
      </div>
    </div>
  )
}
